module.exports = __webpack_public_path__ + "static/media/07.db1ca092.mp3";